import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const getLinkClasses = (path) => {
    const baseClasses = "relative no-underline text-base font-medium transition-all duration-300 py-1 hover:text-indigo-700 after:content-[''] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:bg-gradient-to-r after:from-indigo-600 after:to-violet-600 after:transition-all after:duration-300 hover:after:w-full";
    const activeClasses = "text-indigo-700 after:w-full";
    const inactiveClasses = "text-[#424242] after:w-0";

    return `${baseClasses} ${isActive(path) ? activeClasses : inactiveClasses}`;
  };

  return (
    <nav className="flex justify-between items-center px-5 py-2.5 md:px-10 bg-white shadow-md sticky top-0 z-[1000] font-sans transition-shadow duration-300 hover:shadow-lg relative">
      <Link to="/" className="flex items-center gap-4 no-underline transition-transform duration-300 hover:scale-105 ">
        <img src="/favicon.ico" alt="Kids Work Logo" className="h-9 md:h-[45px] w-auto object-contain rounded-lg" />
        <div className="flex flex-col items-start gap-0.5">
          <span style={{ fontFamily: "'Comic Neue', cursive" }} className="text-indigo-700 text-xl md:text-[1.75em] font-bold bg-gradient-to-br from-indigo-700 to-violet-600 bg-clip-text text-transparent leading-none">Kids Work</span>
          <span style={{ fontFamily: "'Comic Neue', cursive" }} className="text-indigo-700 text-xs md:text-[0.95em] font-medium font-semibold  tracking-[0.15em] uppercase opacity-85">Rehab Center</span>
        </div>
      </Link>

      {/* Desktop Menu */}
      <ul className="flex list-none m-0 p-0 gap-4 md:gap-8 hidden md:flex">
        <li>
          <Link to="/" className={getLinkClasses('/')}>Home</Link>
        </li>
        <li>
          <Link to="/branches" className={getLinkClasses('/branches')}>Our Branches</Link>
        </li>
        <li>
          <Link to="/gallery" className={getLinkClasses('/gallery')}>Gallery</Link>
        </li>
        <li>
          <Link to="/blog" className={getLinkClasses('/blog')}>Blog</Link>
        </li>
        <li>
          <Link to="/about" className={getLinkClasses('/about')}>About</Link>
        </li>
        <li>
          <Link to="/contact" className={getLinkClasses('/contact')}>Contact Us</Link>
        </li>
      </ul>

      <div className="flex items-center gap-3 md:gap-0">
        {/* Hamburger Menu Button */}
        <button
          onClick={toggleMenu}
          className="block md:hidden text-indigo-700 p-2 focus:outline-none"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        <Link to="/branches" className="hidden md:inline-block bg-gradient-to-br from-indigo-600 to-violet-600 text-white no-underline px-4 py-2 md:px-6 md:py-2.5 rounded-full font-semibold cursor-pointer shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:bg-gradient-to-br hover:from-indigo-700 hover:to-violet-700 active:translate-y-0 text-sm md:text-base whitespace-nowrap">
          Online Booking
        </Link>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="absolute top-[100%] left-0 w-full bg-white shadow-xl flex flex-col p-4 md:hidden border-t border-gray-100">
          <Link to="/" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium border-b border-gray-100 hover:bg-gray-50 hover:text-indigo-700 rounded-lg">Home</Link>
          <Link to="/branches" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium border-b border-gray-100 hover:bg-gray-50 hover:text-indigo-700 rounded-lg">Our Branches</Link>
          <Link to="/gallery" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium border-b border-gray-100 hover:bg-gray-50 hover:text-indigo-700 rounded-lg">Gallery</Link>
          <Link to="/blog" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium border-b border-gray-100 hover:bg-gray-50 hover:text-indigo-700 rounded-lg">Blog</Link>
          <Link to="/about" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium hover:bg-gray-50 hover:text-indigo-700 rounded-lg">About</Link>
          <Link to="/contact" onClick={closeMenu} className="py-3 px-4 text-[#424242] font-medium hover:bg-gray-50 hover:text-indigo-700 rounded-lg">Contact Us</Link>
          <Link to="/branches" onClick={closeMenu} className="py-3 px-4 text-indigo-700 font-semibold hover:bg-gray-50 hover:text-indigo-800 rounded-lg">Book Online</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

